import { isObject } from './utils';
import { hasMultilineAddress } from './has-multiline-address';
const removeFalsyValues = (values = {}) => {
    return Object.keys(values).reduce((withoutFalsy, target) => {
        const value = values[target];
        if (value === '' || typeof value === 'undefined' || value === null) {
            return withoutFalsy;
        }
        if (Array.isArray(value) && !value.length) {
            return withoutFalsy;
        }
        if (isObject(value)) {
            withoutFalsy[target] = removeFalsyValues(value);
        }
        else {
            withoutFalsy[target] = value;
        }
        return withoutFalsy;
    }, {});
};
export const validate = async (form, values, addressTemplates, libraryBasedPhoneFieldValidationEnabled) => {
    if (!form.id) {
        return;
    }
    const [{ FormValidator }, { MultilineAddressToolkit }] = await Promise.all([
        import(/* webpackChunkName: "form-validator" */ '@wix/form-validator'),
        import(
        /* webpackChunkName: "form-multiline-address" */ '@wix/form-multiline-address'),
    ]);
    let formValidator;
    if (addressTemplates) {
        const addressForms = addressTemplates.map((template) => template.template);
        const addressToolkit = new MultilineAddressToolkit(addressForms);
        formValidator = new FormValidator([form], undefined, false, addressToolkit.getFormForValidation, addressToolkit.normalizeEmptyValues, libraryBasedPhoneFieldValidationEnabled);
    }
    else {
        formValidator = new FormValidator([form], undefined, undefined, undefined, undefined, libraryBasedPhoneFieldValidationEnabled);
    }
    return formValidator.validate(form.id, hasMultilineAddress(form) ? values : removeFalsyValues(values));
};
//# sourceMappingURL=validation.js.map